export const DATA_TESTID_OFFER_ADMISSION_TYPE = 'admission-type';

export const DATA_TESTID_ADMISSION_MODAL_TICKET_STEP_TITLE = 'admission-modal-ticket-step';
